export function setupIpxClass() {
  var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent); // Define the users device screen dimensions

  var screen = {
    width: window.screen.width,
    height: window.screen.height
  }; // iPhone X Detection

  if (iOS && (screen.width === 375 && screen.height === 812 || screen.width === 812 && screen.height === 375)) {
    document.body.classList.add('ipx');
  } // iPhone X Max Detection


  if (iOS && (screen.width === 414 && screen.height === 896 || screen.width === 896 && screen.height === 414)) {
    document.body.classList.add('ipx');
    document.body.classList.add('ipx-max');
  }
}